import { getApiKey } from 'utils/environment';

// function to verify if we are in a market that does not use Branch
export const isBranchUnavailable = (): boolean => {
  return !getApiKey('branch');
};
